import { useEffect, useState } from 'react'

export function useAccessibilityMode() {
	const [isAccessible, setIsAccessible] = useState(false)

	useEffect(() => {
		const savedMode = localStorage.getItem('accessibilityMode')
		if (savedMode === 'true') {
			enableAccessibility()
		}
	}, [])

	const enableAccessibility = () => {
		document.body.classList.add('accessibility-mode')
		localStorage.setItem('accessibilityMode', 'true')
		setIsAccessible(true)
	}

	const disableAccessibility = () => {
		document.body.classList.remove('accessibility-mode')
		localStorage.setItem('accessibilityMode', 'false')
		setIsAccessible(false)
	}

	return { isAccessible, enableAccessibility, disableAccessibility }
}
